// apiClient.ts
import axios, { AxiosInstance } from 'axios';

const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// レスポンスインターセプターの設定
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // エラーレスポンスのチェック：Unauthenticatedの場合かつ現在のパスに/adminが含まれている場合のみリダイレクト
    if (
      error.response &&
      error.response.data.message === 'Unauthenticated.' &&
      window.location.pathname.includes('/admin')
    ) {
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
